import styled from "styled-components";
import LayoutScrollTop from "../scroll-top";

export const StyledLayoutCorporate = styled(LayoutScrollTop)``;
